import React, { useState, useRef } from "react";
import { dropdownItemSelected } from "./types";
import { useOutsideAlerter } from "../../helpers";

export default ({
  onClick,
  options,
  optionOnClick,
  className,
  value
}: {
  onClick?: Function;
  options: any[];
  optionOnClick: any;
  value: string;
  className?: string;
}) => {
  const [state, categoriesToggle] = useState(true);
  let ref = useRef(null);

  useOutsideAlerter({
    ref,
    condition: true,
    callback: () => {
      if (!state) {
        categoriesToggle(true);
      }
    }
  });

  return (
    <div className={className} ref={ref}>
      <div
        onClick={() => {
          categoriesToggle(!state);
          if (onClick) onClick(state);
        }}
        className={`whatson-advanced-filters-dropdown dropdown${
          state ? "" : " expanded"
        }`}
      >
        {value}
        <span className="icon" />
      </div>
      <div
        className={`whatson-advanced-filters-options${state ? " hide" : ""}`}
      >
        {options.map((cat: dropdownItemSelected) => (
          <div
            key={cat.value}
            className={`whatson-advanced-filters-label${
              cat.selected ? " active" : ""
            }`}
            onClick={() => {
              optionOnClick(cat);
              categoriesToggle(true);
            }}
          >
            {cat.label}
          </div>
        ))}
      </div>
    </div>
  );
};
